// Parking slot types
export enum ParkingType {
  RENTED = 'RENTED',
  PUBLIC = 'PUBLIC',
  DEDICATED = 'DEDICATED',
}

export enum SlotStatus {
  AVAILABLE = 'AVAILABLE',
  OCCUPIED = 'OCCUPIED',
}

export interface ParkingSlot {
  id: string;
  name: string;
  type: ParkingType;
  status: SlotStatus;
  geofence: [number, number][]; // Array of lat/lng coordinates for polygon
  center: [number, number]; // Center point for the slot
}

export interface ParkingArea {
  id: string;
  name: string;
  type: ParkingType;
  capacity: number;
  occupied: number;
  distance: number; // Distance from hotel in km
  geofence: [number, number][]; // Array of lat/lng coordinates for polygon
  center: [number, number]; // Center point
  slots: ParkingSlot[];
}

// Vehicle defect location enum
export enum DefectLocation {
  FRONT = 'FRONT',
  BACK = 'BACK',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP',
  INTERIOR = 'INTERIOR',
}

// Vehicle defect types
export interface VehicleDefect {
  id: string;
  location: DefectLocation;
  description: string;
  severity: 'MINOR' | 'MODERATE' | 'SEVERE';
  photoUrl?: string;
  notes?: string;
  reportedAtCheckIn: boolean;
}

// Vehicle types
export interface Vehicle {
  id: string;
  licensePlate: string;
  make: string;
  model: string;
  year: number;
  color: string;
  type: string;
  slotId: string | null;
  areaId: string;
  checkInTime: string;
  checkOutTime: string | null;
  expectedDuration: number; // in hours
  status: 'PARKED' | 'LEFT';
  charges?: {
    base: number;
    additional: number;
    total: number;
    paid: boolean;
  };
  customerDetails?: {
    name: string;
    contact: string;
    email?: string;
    roomNumber?: string;
    isGuest: boolean;
  };
  defects: VehicleDefect[];
  inspectionNotes?: string;
  handledBy: string; // Staff ID who handled check-in
}

// Dashboard stats
export interface ParkingStats {
  totalCapacity: number;
  totalOccupied: number;
  occupancyRate: number;
  areaStats: {
    [key: string]: {
      capacity: number;
      occupied: number;
      rate: number;
    };
  };
  parkingTypeStats: {
    [key in ParkingType]: {
      capacity: number;
      occupied: number;
      rate: number;
    };
  };
  hourlyStats: {
    hour: number;
    occupied: number;
  }[];
}